import CarriersConfigurations from "@/components/logistics/carriers/carriers-configurations";
import CalendarConfiguration from "@/components/logistics/configuration/calendar-configuration";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/carriers",
)({
  component: CalendarsPage,
});

function CalendarsPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "carriers", actions: ["read", "update"] }]}
    >
      <CarriersConfigurations />
    </RouteGuardPermissions>
  );
}
